export default __webpack_public_path__ + "static/media/4.560318ae.png";